import type { RouteRecordRaw } from 'vue-router'

// 品牌与企业话术是独立业务页面，不进入公司智能体工作台。
const aiBrainRoutes: RouteRecordRaw[] = [
  {
    path: 'knowledge-phrases',
    name: 'KnowledgePhraseList',
    component: () => import('@/pages/knowledge-phrases/KnowledgePhrasePage.vue'),
    meta: { title: '企业话术库', parent: '配置', fullHeight: true },
  },
  {
    path: 'ai-brain',
    name: 'BrandList',
    component: () => import('@/pages/brand/BrandList.vue'),
    meta: { title: '品牌知识库', parent: '配置', fullHeight: true },
  },
  {
    path: 'ai-brain/create',
    name: 'BrandCreate',
    component: () => import('@/pages/brand/BrandList.vue'),
    meta: { title: '新建品牌', parent: '配置', fullHeight: true },
  },
  {
    path: 'ai-brain/:id',
    name: 'BrandDetail',
    component: () => import('@/pages/brand/BrandList.vue'),
    meta: { title: '品牌详情', parent: '配置', fullHeight: true },
  },
]

export default aiBrainRoutes
